import React from 'react'

export default function Chiffre() {
    return (
        <div className="section panel overflow-hidden">
            <div className="section-outer panel py-1 md:py-1 lg:py-1 xl:py-1 dark:bg-gray-900">
                <div className="container max-w-2xl p-0 sm:px-2 lg:px-4 xl:px-0">
                    <div className="section-inner">
                        <div className="block-layout grid-layout vstack gap-1 sm:gap-1 xl:gap-5 panel">
                            <div className="block-header px-2 lg:px-0 text-center">
                                <h2 className="h4 md:h3 m-0">
                                    <i className="fas fa-trophy text-primary"></i>
                                    <span>Nos Réalisations</span>
                                </h2>
                                <p className="fs-6 mt-2 text-gray-600 dark:text-gray-400">Transformer des vies à travers le basketball</p>
                            </div>
                            <div className="block-content bg-primary bg-opacity-5 rounded-lg p-3 md:p-4 lg:p-6">

                                {/* Chiffres clés */}
                                <div className="panel mt-4 p-1">
                                    <div className="row child-cols-12 sm:child-cols-4 g-4 text-center">
                                        <div>
                                            <div className="vstack gap-1">
                                                <i className="fas fa-basketball-ball text-primary text-xl"></i>
                                                <h4 className="h3 m-0 text-primary">250+</h4>
                                                <p className="fs-7 m-0">Jeunes formés</p>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="vstack gap-1">
                                                <i className="fas fa-graduation-cap text-primary text-xl"></i>
                                                <h4 className="h3 m-0 text-primary">85%</h4>
                                                <p className="fs-7 m-0">Réussite scolaire</p>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="vstack gap-1">
                                                <i className="fas fa-medal text-primary text-xl"></i>
                                                <h4 className="h3 m-0 text-primary">15</h4>
                                                <p className="fs-7 m-0">Titres remportés</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
